import { timeout } from '@/shared/lib/utils/timeout';

export const leaveInstant = (): Promise<void> => timeout(50).then(() => Promise.resolve());
